module.exports = __webpack_public_path__ + "img/public/SiteIcons/facebookIconBlack.svg?f6fe5216";